var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between items-center px-4 py-2 bg-primary-100 rounded-t-xl text-sm"},[_c('span',[_vm._v(" "+_vm._s(_vm.actionsHeader))]),_c('button',{staticClass:"font-bold",class:{
      'text-main': !_vm.isFullLogicShown && _vm.isConditionsPartiallyFilled,
      'text-base-content-100': _vm.isFullLogicShown || !_vm.isConditionsPartiallyFilled,
    },attrs:{"type":"button","disabled":!_vm.isConditionsPartiallyFilled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t("components.workflow.view_logic"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }